var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReminders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.052,
    height: 19.317,
    viewBox: "0 0 18.052 19.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_notification_4307661",
    transform: "translate(-1.801 -0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45435",
    "data-name": "Path 45435",
    d: "M27.153,11.8a.631.631,0,0,0,.631-.631A8.75,8.75,0,0,0,25.067,4.8a.63.63,0,1,0-.873.91,7.5,7.5,0,0,1,2.328,5.455A.631.631,0,0,0,27.153,11.8Z",
    transform: "translate(-8.128 -1.34)",
    stroke: "#8A8A8A",
    fill: "#8A8A8A",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45436",
    "data-name": "Path 45436",
    d: "M4.716,4.8A8.75,8.75,0,0,0,2,11.168a.631.631,0,1,0,1.261,0A7.5,7.5,0,0,1,5.589,5.713a.63.63,0,1,0-.873-.91Z",
    transform: "translate(0 -1.34)",
    stroke: "#8A8A8A",
    fill: "#8A8A8A",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45437",
    "data-name": "Path 45437",
    d: "M4.525,9.828V13.05a.562.562,0,0,1-.561.561A1.944,1.944,0,0,0,2.03,15.185a1.912,1.912,0,0,0,1.864,2.21H8.308a2.522,2.522,0,1,0,5.045,0h4.414a1.924,1.924,0,0,0,1.864-2.21A1.944,1.944,0,0,0,17.7,13.611a.562.562,0,0,1-.561-.561V9.828A6.312,6.312,0,0,0,12.5,3.755a1.868,1.868,0,0,0,.218-.863,1.892,1.892,0,1,0-3.783,0,1.868,1.868,0,0,0,.218.863A6.312,6.312,0,0,0,4.525,9.828Zm6.306,8.828a1.263,1.263,0,0,1-1.261-1.261h2.522A1.263,1.263,0,0,1,10.83,18.656ZM10.2,2.892a.631.631,0,1,1,.631.631A.631.631,0,0,1,10.2,2.892Zm.631,1.892a5.05,5.05,0,0,1,5.045,5.045V13.05A1.824,1.824,0,0,0,17.7,14.872a.684.684,0,0,1,.69.52.637.637,0,0,1-.62.741H3.894a.636.636,0,0,1-.619-.743.683.683,0,0,1,.689-.518A1.824,1.824,0,0,0,5.786,13.05V9.828A5.05,5.05,0,0,1,10.83,4.783Z",
    transform: "translate(-0.002 0)",
    fill: "#8A8A8A",
    stroke: "#8A8A8A",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminders);
export default __webpack_public_path__ + "static/media/reminders.4f2c4c99.svg";
export { ForwardRef as ReactComponent };